import axios from "axios";

const baseUrl = "/AutoConnectSSO/api/Shared/User/";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function existsByEmail(email: string) {
  const url = `ExistByEmail`;
  const response = await instance.post(url, JSON.stringify(email), {
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response.data;
}

async function existsByNationalId(nationalId: string) {
  const url = `ExistByNationalId`;
  const response = await instance.post(url, JSON.stringify(nationalId), {
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response.data;
}

export const UserService = {
  existsByEmail,
  existsByNationalId
};
